import { configConstants as annes } from "../../../constants/configs";

const initialState = { loading: true, list: [], annee: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case annes.GET_ANNEES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case annes.GET_ANNEE:
      return {
        ...state,
        loading: false,
        annee: payload,
      };
    default:
      return state;
  }
}
